import {EventEmitter} from "@/helpers/EventEmitter";
import {BaseApi} from "@/core/services/MedicaPro/BaseApi";
import _ from "lodash";

export class Filter {

    // Filter
    private category?: string;
    private identifiers?: string[];

    // Events
    public onChange = new EventEmitter();

    // Debounce
    private onChangeDebounce = _.debounce(() => this.onChange.emit(), 500);

    constructor() {
    }

    public reset(emit = false) {
        this.identifiers = undefined;

        if (emit) {
            this.onChangeDebounce();
        }
    }

    public setCategory(value: string | undefined, emit = false) {
        this.category = value;
        if (emit) {
            this.onChangeDebounce();
        }
    }

    public getCategory(): string | undefined {
        return this.category;
    }

    public setIdentifiers(value: string[] | undefined, emit = false) {
        this.identifiers = value;
        if (emit) {
            this.onChangeDebounce();
        }
    }

    public getIdentifiers(): string[] | undefined {
        return this.identifiers;
    }

    public applyApiFilters(api: BaseApi) {
        if (this.category) {
            api.where('category', this.category);
        }

        if (this.identifiers) {
            api.whereIn('measurement_type_identifier', this.identifiers);
        }
    }

}
